/**
 * @file index.ts
 *
 * @fileoverview Get landing page organizations query and helper methods.
 */

import GET_FEATURED_ORGANIZATIONS from './landingpageOrganizations.gql';
/**
 * Returns the appropriate variables for the organizations query of landing pages.
 *
 * @param ctx
 *   The app context.
 * @param industry
 *   Industry filter for organizations.
 *
 * @returns
 *   Variables information for querying organizations.
 */
export const getLandingPageOrganizationsVariables = (
  ctx: any,
  organizationsConfig,
  industry: number | null = null,
) => {
  const featuredOrganizations =
    organizationsConfig.FEATURED_ORGANIZATIONS_SETTINGS;

  return {
    language: ctx.locale,
    range: {
      first: featuredOrganizations.RANGE.FIRST,
      last: featuredOrganizations.RANGE.LAST,
    },
    featuredOnly: organizationsConfig.SHOW_ONLY_FEATURED_ORGANIZATIONS,
    ...(industry !== null && { industry }),
  };
};

export { GET_FEATURED_ORGANIZATIONS };
